import styled from "styled-components";

const Section = styled.section`
  width: 100%;
  background-color: ${(props) => props.$bgColor || "#F7F5F1"};
  box-shadow: 0 0 0 100vmax ${(props) => props.$bgColor || "#F7F5F1"};
  clip-path: inset(0 -100vmax);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px 0;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 36px 0;
  }

  @media (max-width: 480px) {
    padding: 12px 0;
  }
`;

export default function BackgroundSection({ children, bgColor, className }) {
  return (
    <Section $bgColor={bgColor} className={className}>
      {children}
    </Section>
  );
}
